module.exports = __webpack_public_path__ + "img/stepFirst.9e2d65bf.png";